import React, { useEffect, useState } from 'react';
import { Container } from '@mantine/core';

const DatenschutzPage: React.FC = () => {
  const [htmlContent, setHtmlContent] = useState<string>('');

  useEffect(() => {
    // Lade die HTML-Datei aus dem public-Ordner
    fetch('/datenschutz.html', {
      headers: {
        'Content-Type': 'text/html; charset=UTF-8'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Fehler beim Laden der Datenschutzerklärung');
        }
        return response.text();
      })
      .then(html => setHtmlContent(html))
      .catch(error => console.error(error));
  }, []);
  return (
    <Container size="md" style={{ padding: '2rem' }}>
      {htmlContent ? (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      ) : (
        <p>Lade Datenschutzerklärung...</p>
      )}
    </Container>
  );
};

export default DatenschutzPage;
